module.exports = {"TAG_DEFAULT_INPUT_PLACEHOLDER":"Has llegado al límite de elementos","TAG_ADD_BUTTON":"Agregar","TAG_INVALID_VALUE":"Valor inválido"}